const INSERT_EVENT_BUTTON = "insert-event-button";
const INSERT_BOOKINGS_BUTTON = "insert-bookings-button";
const INSERT_STORES_BUTTON = "insert-stores-button";
const ROOT = "vertical-embed";
const INSERT_VERTICAL_EMBED_MODAL = "insert-vertical-embed-modal";
const INSERT_VERTICAL_EMBED_SEARCH_INPUT = "insert-vertical-embed-modal-search-input";
const INSERT_VERTICAL_EMBED_MODAL_ITEM = "insert-vertical-embed-item";
const INSERT_VERTICAL_EMBED_MODAL_ITEM_IMAGE = "insert-vertical-embed-item-image";
const INSERT_VERTICAL_EMBED_CANCEL_BUTTON = "vertical-embed-cancel-button";
const INSERT_VERTICAL_EMBED_FOOTER_ACTIONS = "vertical-embed-footer-actions";
const INSERT_VERTICAL_EMBED_ITEMS_LIST = "vertical-embed-items-list";
const VERTICAL_EMBED_TITLE = "vertical-embed-title";
const VERTICAL_EMBED_BUTTON = "vertical-embed-button";
const VERTICAL_EMBED_SUBTITLE = "vertical-embed-subtitle";
export {
  INSERT_BOOKINGS_BUTTON,
  INSERT_EVENT_BUTTON,
  INSERT_STORES_BUTTON,
  INSERT_VERTICAL_EMBED_CANCEL_BUTTON,
  INSERT_VERTICAL_EMBED_FOOTER_ACTIONS,
  INSERT_VERTICAL_EMBED_ITEMS_LIST,
  INSERT_VERTICAL_EMBED_MODAL,
  INSERT_VERTICAL_EMBED_MODAL_ITEM,
  INSERT_VERTICAL_EMBED_MODAL_ITEM_IMAGE,
  INSERT_VERTICAL_EMBED_SEARCH_INPUT,
  ROOT,
  VERTICAL_EMBED_BUTTON,
  VERTICAL_EMBED_SUBTITLE,
  VERTICAL_EMBED_TITLE
};
//# sourceMappingURL=data-hooks.js.map
